/**
 * Created by mykurisu on 2017/9/18.
 */
import React from 'react'


class WKSquareButton extends React.Component {
    static defaultProps = {
        blockContent: {
            img: '',
            text: '',
            method: () => {},
            //无icon时
            color: 'rgba(0,0,0,0)',
            iconText: ''
        },
        nopic: false,
        hasBanner: false,
        bannerText: '',
        hasContent: true
    };

    render() {
        const {blockContent, nopic, hasBanner, bannerText, hasContent} = this.props;

        if (!hasContent){
            return null
        }

        return (
            <div className="wk-square-button" onClick={() => {
                this.props.handleSheetHide();
                blockContent.method();
            }}>
                {hasBanner &&
                <div className="wk-square-button-banner">
                    <span>{bannerText}</span>
                </div>
                }
                {nopic &&
                <div className="wk-square-button-img" style={{backgroundColor: blockContent.color}}>
                    {blockContent.iconText}
                </div>
                }
                {!nopic &&
                <div className="wk-square-button-img">
                    {blockContent.text !== 'VIP推送'&&
                        <div style={{position:'relative'}}>
                            <img src={blockContent.img} alt=""/>
                            {blockContent.numTag > 0 &&
                                <span className="square-red" style={{
                                    width: blockContent.numTag > 99 ? '27px' : blockContent.numTag >10 ? '20px' : '14px',
                                    borderRadius: blockContent.numTag > 99 ? '10px' : blockContent.numTag >10 ? '10px' : '50%',
                                    right: blockContent.numTag > 99 ? '-13px' : blockContent.numTag >10 ? '-9px' : '-4px',
                                }}>{blockContent.numTag > 99 ? '99+' : blockContent.numTag}</span>
                            }
                        </div>
                    }
                    {blockContent.text === 'VIP推送' &&
                        <img src="https://static-1253442168.image.myqcloud.com/picture/4557647_d776273ad165b630437dc060cde6b686.jpg" alt=""/>
                    }
                    
                </div>
                }
                <div className="wk-square-button-text">
                    {blockContent.text}
                </div>
            </div>
        )
    }
}

export default WKSquareButton


// WEBPACK FOOTER //
// ./src/components/wk/WKSquareButton.js